import * as React from 'react';
import { withBaseProps } from '@topconagriculture/react-components';
import { compose } from 'recompose';
import { createStyles } from '@material-ui/styles';
import { border } from '@topconagriculture/theme';
const styles = (theme) => createStyles({
    userHeaderContent: {
        display: 'flex',
        flexDirection: 'row',
        padding: '20px',
        backgroundColor: theme.components.userMenu.colors.headerBackground,
        width: '100%',
        height: 110,
        color: theme.components.userMenu.colors.headerText,
        borderRadius: '5px 5px 0 0',
    },
    userIcon: {
        width: '68px',
        height: '68px',
        lineHeight: '68px',
        textAlign: 'center',
        backgroundColor: theme.components.userMenu.colors.userIconBackground,
        border: border('white'),
        borderRadius: '100%',
        fontSize: '26px',
        textTransform: 'uppercase',
        color: theme.components.userMenu.colors.userIconText,
        '-webkit-touch-callout': 'none',
        '-webkit-user-select': 'none',
        '-khtml-user-select': 'none',
        '-moz-user-select': 'none',
        '-ms-user-select': 'none',
        'user-select': 'none',
    },
    userData: {
        display: 'flex',
        flexDirection: 'column',
        paddingLeft: '15px',
        justifyContent: 'center',
    },
    userName: {
        fontSize: '16px',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        width: '175px',
        whiteSpace: 'nowrap',
    },
    userEmail: {
        fontSize: theme.font.size.mediumSmall,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        width: '175px',
        whiteSpace: 'nowrap',
    },
});
const UserMenuHeader = (props) => {
    const { classes, user } = props;
    const firstNameAndSurnameLetters = `${user.firstName[0]}${user.lastName[0]}`;
    return (React.createElement("div", { className: classes.userHeaderContent, "data-testid": 'user-menu-header' },
        React.createElement("div", { className: classes.userIcon }, firstNameAndSurnameLetters),
        React.createElement("div", { className: classes.userData },
            React.createElement("div", { className: classes.userName, title: `${user.firstName} ${user.lastName}`, "data-testid": 'user-menu-header-name' },
                user.firstName,
                " ",
                user.lastName),
            React.createElement("div", { className: classes.userEmail, title: user.email, "data-testid": 'user-menu-header-email' }, user.email))));
};
export default compose(withBaseProps({ styles }))(UserMenuHeader);
//# sourceMappingURL=UserMenuHeader.js.map